import { render } from "./NotificationInbox.vue?vue&type=template&id=06d92e29"
import script from "./NotificationInbox.vue?vue&type=script&lang=js"
export * from "./NotificationInbox.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\takht-jamshid\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__